import { render, staticRenderFns } from "./smartVillage.vue?vue&type=template&id=e1a31a40&scoped=true"
import script from "./smartVillage.vue?vue&type=script&lang=js"
export * from "./smartVillage.vue?vue&type=script&lang=js"
import style0 from "./smartVillage.vue?vue&type=style&index=0&id=e1a31a40&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1a31a40",
  null
  
)

export default component.exports